import { render, staticRenderFns } from "./BannerDetail2.vue?vue&type=template&id=1267c2b6&scoped=true&"
import script from "./BannerDetail2.vue?vue&type=script&lang=js&"
export * from "./BannerDetail2.vue?vue&type=script&lang=js&"
import style0 from "./BannerDetail2.vue?vue&type=style&index=0&id=1267c2b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1267c2b6",
  null
  
)

export default component.exports